import React from 'react';
import { faCloudShowersHeavy } from '@fortawesome/pro-regular-svg-icons/faCloudShowersHeavy';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function CloudShowersHeavyRegularIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faCloudShowersHeavy} {...props} />;
}
